import { css } from "@stubhub/broadway-foundation/css";

export const numTicketsPurchasedContainer = css({
  display: "flex",
  alignItems: "center",
});
